import * as EventListener from "../common/helpers/event-listener";

const showSorting = () => {
    EventListener.click("sorting-button", (button) => {
        const sortingDropdown = document.querySelector(".sort-dropdown-list");
        const hiddenClass = "hidden";

        if (sortingDropdown.classList.contains(hiddenClass)) {
            sortingDropdown.classList.remove(hiddenClass);
            document.addEventListener("click", clickSortingOutside);
        } else {
            sortingDropdown.classList.add(hiddenClass);
            document.removeEventListener("click", clickSortingOutside);
        }

        button.disabled = false;
    });
};

const clickSortingOutside = (event) => {
    const blockClass = "sort-dropdown-list";
    const hiddenClass = "hidden";
    const block = document.querySelector("." + blockClass);

    if (block) {
        if (event.target.classList.contains(blockClass)) {
            return;
        }

        if (!block.classList.contains(hiddenClass)) {
            block.classList.add(hiddenClass);

            document.removeEventListener("click", clickSortingOutside);
        }
    }
};

showSorting();
